import type { V1Step } from '@/generated/hooks/grimoire/models';

export interface IStepPhaseGroup {
  /** Phase title (the nearest preceding `phase("...")` marker). Empty string
   *  when the step precedes any marker. */
  phase: string;
  steps: V1Step[];
}

/**
 * Groups steps by `phase`, preserving step order. `CodeManifest` carries no
 * separate phase list — the manifest.proto comment on `Step.phase` is
 * explicit that consumers derive it from steps in order — so a new group
 * starts whenever `phase` differs from the previous step's.
 */
export function groupStepsByPhase(steps: V1Step[] = []): IStepPhaseGroup[] {
  const groups: IStepPhaseGroup[] = [];

  for (const step of steps) {
    const phase = step.phase ?? '';
    const currentGroup = groups[groups.length - 1];

    if (currentGroup && currentGroup.phase === phase) {
      currentGroup.steps.push(step);
    } else {
      groups.push({ phase, steps: [step] });
    }
  }

  return groups;
}
